<template>
  <div>
    <template v-if="followable_status == consts.PERFORMER_FOLLOW_STATUS.DEFAULT">
      <loading style="margin: auto; margin-top: 40px;"></loading>
    </template>
    <template v-else-if="followable_status == consts.PERFORMER_FOLLOW_STATUS.UN_FOLLOWABLE">
      <div class="pg-performer-events--buttton__squre pg-performer-events--buttton__un_follow" v-on:click="un_follow_performer">
        <p>フォローしています</p>
      </div>
    </template>
    <template v-else>
      <div class="pg-performer-events--buttton__squre pg-performer-events--buttton__follow" v-on:click="follow_performer">
        <p>フォローする</p>
      </div>
      <div class="pg-performer-events--label__follow">
        フォローすると最新イベント情報が届きます！
      </div>
    </template>
  </div>
</template>

<script>
import consts from '../utils/consts'

export default {
  props: {
    uid: { type: Number, required: true },
    followable: { type: Boolean, required: true },
    follow_path: { type: String, required: true },
    un_follow_path: { type: String, required: true },
  },
  data() {
    return {
    }
  },
  created(){
    if(0 > this.uid){
      this.$store.commit('performer/setNoLoggedin')
    } else if (this.followable) {
      this.$store.commit('performer/setFollowable')
    } else {
      this.$store.commit('performer/setUnFollowable')
    }
  },
  computed:{
    followable_status: function() {
      return this.$store.getters['performer/follow_status']
    },
    consts: function() {
      return consts
    },
  },
  methods: {
    // フォローボタン押下イベント
    follow_performer: function() {
      setTimeout(function(){
        switch(this.followable_status) {
          case consts.PERFORMER_FOLLOW_STATUS.FOLLOWABLE:
            this.$store.commit('performer/setDefault')
            this.$store.dispatch('performer/performer_follow', {api_path: this.follow_path})
            break
          default:
            $('#noLoggedinFollow').modal('show');
        }
      }.bind(this), 500);
    },

    // フォロー解除ボタン押下イベント
    un_follow_performer: function() {
      this.$store.commit('performer/setDefault')
      setTimeout(
        function() {
          this.$store.dispatch('performer/performer_un_follow', {api_path: this.un_follow_path})
        }.bind(this), 500);
    },
  },
}
</script>


<style lang="scss" scoped>
  @import '../packs/application.css';

</style>
